import React from "react";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import CustomTooltip from "../Tooltip";

const Index = ({ ...other }) => {
  const { t } = useTranslation(["configure"]);

  return (
    <CustomTooltip title={t("Filter")}>
      <Button
        type="primary"
        color="primary"
        style={{ padding: "8px 7px 5px" }}
        {...other}
      >
        <FontAwesomeIcon icon={faFilter} style={{ fontSize: "1.0rem" }} />
      </Button>
    </CustomTooltip>
  );
};

export default Index;
